export const generalDeviceTypesEnum = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
};

export const exactDeviceTypesEnum = {
    DESKTOP: 'desktop',
    TINY_DESKTOP: 'tinyDesktop',
    TABLET: 'tablet',
    MOBILE: 'mobile',
};
